export const DELIVERY_METHOD = {
  EMAIL: 'email',
  POST: 'post',
  PER_DOCUMENT: 'perDocument'
} as const

export type DeliveryMethod =
  (typeof DELIVERY_METHOD)[keyof typeof DELIVERY_METHOD]

export const DOCUMENT_CHANNEL = {
  EMAIL: 'email',
  POST: 'post'
} as const

export type DocumentChannel =
  (typeof DOCUMENT_CHANNEL)[keyof typeof DOCUMENT_CHANNEL]

export const BACKEND_DOCUMENT_CHANNEL = {
  DIGITAL: 'DIGITAL',
  POSTAL: 'POSTAL'
} as const

export type BackendDocumentChannel =
  (typeof BACKEND_DOCUMENT_CHANNEL)[keyof typeof BACKEND_DOCUMENT_CHANNEL]
